//could come back, condense these into a single function

export function drawBGImg1(bgImg1, canvas, dimensions, paths, location, platform) {
    let { w, h, w0, h0 } = dimensions;
    canvas.width = w0;
    canvas.height = h0;
    let c = canvas.getContext('2d');
    c.save()
    c.lineWidth = 30;
    let clippedPath = paths.clippedPath;
    followPath(clippedPath, c, dimensions, platform)
    c.closePath()
    c.clip();
    //scale image
    let bgW = bgImg1.width;
    let bgH = bgImg1.height;
    let destW, destH, cW, cH;
    switch (platform) {
    case 'desktop':
        switch (location.pathname) {
        default:
            destW = w[74]; cW = w[37];
            destH = h[88]; cH = h[50];
            break;
        }
        break;
    case 'tablet':
    case 'mobile':
    default:
        switch (location.pathname) {
        case '/':
        case '/about':
            destW = w[96]; cW = w[50];
            destH = h[88]; cH = h[30]; //shifted center by 7 units, so had to increase overall height by 14
            break;
        default:
            destW = w[96]; cW = w[50];
            destH = h[74]; cH = h[37];
            break;
        }
    }
    let s = scale(bgW, bgH, destW, destH)
    bgW *= s;
    bgH *= s;

    //centers image by specifying start of destination rectangle off screen; 
    c.drawImage(bgImg1, 0, 0, bgImg1.width, bgImg1.height,
        cW - bgW / 2, cH - bgH / 2, bgW, bgH) //h[50] midpoint between h[6] and h[94], w[37] midpoint between 0 and w[74]
    // c.strokeStyle = 'blue'
    c.globalCompositeOperation = 'destination-out';
    followPath(clippedPath, c, dimensions, platform);
    // c.closePath()
    c.stroke();
    c.globalCompositeOperation = 'source-over';
    c.restore();
}

export function drawBGImg2(bgImg2, canvas, dimensions, paths, location, platform) {
    let { w, h, } = dimensions;
    //was already set when drawing first img
    // canvas.width = w0;
    // canvas.height = h0;
    let c = canvas.getContext('2d');
    c.save()
    c.lineWidth = 30;
    let clippedPath = paths.clipped2;
    followPath(clippedPath, c, dimensions, platform)
    c.closePath()
    c.clip();
    //scale image
    let bgW = bgImg2.width;
    let bgH = bgImg2.height;
    let destW, destH, cW, cH;
    switch (platform) {
    case 'desktop':
        switch (location.pathname) {
        case '/contact':
            destW = w[54]; cW = w[83]; //notice translated center right by 5 units (78 to 83), means I had to increase overall destW by 10 units (44 - 54)
            destH = h[98]; cH = h[55];
            break;
        default:
            destW = w[44]; cW = w[78];
            destH = h[88]; cH = h[50];
            break;
        }
        break;
    case 'tablet':
    case 'mobile':
    default:
        switch (location.pathname) {
        case '/projects':
            destW = w[96]; cW = w[50];
            destH = h[51]; cH = h[82];
            break;
        default:
            destW = w[96]; cW = w[50];
            destH = h[46]; cH = h[77];
            break;
        }
        break;
    }
    let s = scale(bgW, bgH, destW, destH)
    bgW *= s;
    bgH *= s;

    //centers image by specifying start of destination rectangle off screen; 
    c.drawImage(bgImg2, 0, 0, bgImg2.width, bgImg2.height,
        cW - bgW / 2, cH - bgH / 2, bgW, bgH) //h[50] midpoint between h[6] and h[94], w[37] midpoint between 0 and w[74]
    // c.strokeStyle = 'blue'
    c.globalCompositeOperation = 'destination-out';
    followPath(clippedPath, c, dimensions, platform);
    // c.closePath()
    c.stroke();
    c.globalCompositeOperation = 'source-over';
    c.restore();
}
    


//ORIGINAL VERSION, NEEDS TO BE UPDATED
function followPath(path, c, dimensions, platform) {
    // let c = context.current;
    let { w, h, h0, w0 } = dimensions;
    let halfUnit = platform === 'desktop' ? Math.floor(w0 / 200) : Math.floor(h0 / 200);
    c.beginPath();
    c.moveTo(w[path[0][0]], h[path[0][1]])
    if (platform === 'desktop') {
        for (let i = 1; i < path.length; i++) {
            c.lineTo(w[path[i][0]] + (path[i][2] ? halfUnit : 0), h[path[i][1]])
        }
    }
    else {
        for (let i = 1; i < path.length; i++) {
            c.lineTo(w[path[i][0]], h[path[i][1]] + (path[i][2] ? halfUnit : 0))
        }

    }
}

function scale(bgW, bgH, destW, destH) {
    let scale = 1;
    if (bgW < destW || bgH < destH) {
        let scaleW = destW / bgW;
        let scaleH = destH / bgH;
        scale = Math.max(scaleW, scaleH)
    }
    else if (bgW > destW && bgH > destH) {
        let scaleW = destW / bgW;
        let scaleH = destH / bgH;
        scale = Math.max(scaleW, scaleH)
    }
    return scale;
}